export default __webpack_public_path__ + "static/media/concepcion_del_uruguay.f2b7d5d0.jpg";